import { MinimalList } from 'adapters/list/graphqlTypes';

export const ADD_REQUEST = 'FAVOURITE_CLIENT/ADD_TO_FAVOURITES';
export const ADD_LOADING = 'FAVOURITE_CLIENT/ADD_TO_FAVOURITES_INITIATE';
export const ADD_SUCCESS = 'FAVOURITE_CLIENT/ADD_TO_FAVOURITES_SUCCESS';
export const ADD_FAILURE = 'FAVOURITE_CLIENT/ADD_TO_FAVOURITES_FAIL';

// Events that allow to add multiple items to Favourites
export const ADD_ITEMS_REQUEST = 'FAVOURITE_CLIENT/ADD_ITEMS_TO_FAVOURITES';
export const ADD_ITEMS_LOADING = 'FAVOURITE_CLIENT/ADD_ITEMS_TO_FAVOURITES_INITIATE';
export const ADD_ITEMS_SUCCESS = 'FAVOURITE_CLIENT/ADD_ITEMS_TO_FAVOURITES_SUCCESS';
export const ADD_ITEMS_FAILURE = 'FAVOURITE_CLIENT/ADD_ITEMS_TO_FAVOURITES_FAIL';
export const ADD_ITEMS_ABORTED = 'FAVOURITE_CLIENT/ADD_ITEMS_TO_FAVOURITES_ABORTED';

export const REMOVE_REQUEST = 'FAVOURITE_CLIENT/REMOVE_FROM_FAVOURITES';
export const REMOVE_LOADING = 'FAVOURITE_CLIENT/REMOVE_FROM_FAVOURITES_INITIATE';
export const REMOVE_SUCCESS = 'FAVOURITE_CLIENT/REMOVE_FROM_FAVOURITES_SUCCESS';
export const REMOVE_FAILURE = 'FAVOURITE_CLIENT/REMOVE_FROM_FAVOURITES_FAIL';

export const UPDATE_FAVOURITES = 'FAVOURITE_CLIENT/FAVOURITES_UPDATED';

// Inspiration Events
export const ADD_INSPIRATION_REQUEST = 'FAVOURITE_CLIENT/ADD_INSPIRATION';
export const ADD_INSPIRATION_LOADING = 'FAVOURITE_CLIENT/ADD_INSPIRATION_INITIATE';
export const ADD_INSPIRATION_SUCCESS = 'FAVOURITE_CLIENT/ADD_INSPIRATION_SUCCESS';
export const ADD_INSPIRATION_FAILURE = 'FAVOURITE_CLIENT/ADD_INSPIRATION_FAIL';

export const REMOVE_INSPIRATION_REQUEST = 'FAVOURITE_CLIENT/REMOVE_INSPIRATION';
export const REMOVE_INSPIRATION_LOADING = 'FAVOURITE_CLIENT/REMOVE_INSPIRATION_INITIATE';
export const REMOVE_INSPIRATION_SUCCESS = 'FAVOURITE_CLIENT/REMOVE_INSPIRATION_SUCCESS';
export const REMOVE_INSPIRATION_FAILURE = 'FAVOURITE_CLIENT/REMOVE_INSPIRATION_FAIL';

export const UPDATE_INSPIRATIONS = 'FAVOURITE_CLIENT/INSPIRATIONS_UPDATED';

export const AGENT_LOADED = 'FAVOURITE_CLIENT/AGENT_LOADED';

// Events triggered from Cart and Favourites when cart and lists are updated respectively
export const UPDATE_DATA = 'TROJAN_AGENT/UPDATE_DATA';

type FavouriteItemPayload = {
    productName: string;
    productNumber: string;
    productType: string;
    quantity: string;
    ratings?: number;
};

export type InspirationPayload = {
    ids: Array<string>;
    source: string;
};

export type BuyNowPayload = {
    items: Array<{
        productNumber: string;
        quantity: string;
        uom: string;
    }>;
    source?: string;
};

type IncomingFavouritesPayload = {
    data: MinimalList[];
    source: 'favourites';
    store: string;
};
type IncomingInspirationPayload = {
    data: Array<{ id: string }>;
    source: 'inspiration';
    store: string;
};

export type UpdateDataPayload = IncomingFavouritesPayload | IncomingInspirationPayload;

type CommonAttributes = {
    source: string;
    alwaysShowModal?: boolean;
    ga?: {
        custom: any;
    };
};

export type SingleItemPayload = FavouriteItemPayload & CommonAttributes;

export type MultipleItemPayload = {
    items: Array<FavouriteItemPayload>;
} & CommonAttributes;

export type FavouritesPayload = SingleItemPayload | MultipleItemPayload;

export type FavouritesEvent = IkeaEvent<FavouritesPayload>;
export type InspirationEvent = IkeaEvent<InspirationPayload>;
export type UpdateDataEvent = IkeaEvent<UpdateDataPayload>;

export const publish = window.ikea.pubsub.publish;
